import classNames from "classnames";
import { Avatar } from "neetoui";
import PropTypes from "prop-types";

import ActivityIcon from "./Icon";

const Activity = ({
  user,
  icon,
  unread = false,
  className,
  children,
  userIcon,
}) => (
  <div
    className={classNames(
      "neeto-molecules-engagements-node relative -mt-4 flex items-center gap-2 px-4 py-4",
      className
    )}
  >
    <ActivityIcon {...{ icon, unread }} />
    {userIcon || (
      <Avatar
        size="small"
        user={{ name: user.name, imageUrl: user.profileImageUrl }}
      />
    )}
    <div className="neeto-molecules-engagements-node__children">{children}</div>
  </div>
);

Activity.propTypes = {
  /** Object representing the user information  */
  user: PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired,

  /** Element to render as the icon  */
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,

  /** Boolean indicating if the activity is unread to show unread badge */
  unread: PropTypes.bool,

  /**  Additional classes passed on to the board view. */
  className: PropTypes.string,
};

export default Activity;
